var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.activateSpinner
        ? _c("spinner")
        : _c(
            "div",
            [
              _c(
                "b-row",
                [
                  _vm.isEditable
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              inputLabel: _vm.$t("common.security.ca_name"),
                            },
                            model: {
                              value: _vm.name,
                              callback: function ($$v) {
                                _vm.name = $$v
                              },
                              expression: "name",
                            },
                          }),
                        ],
                        1
                      )
                    : _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-read-group-label-input", {
                            attrs: {
                              inputLabel: _vm.$t("common.security.ca_name"),
                              inputValue: _vm.name,
                            },
                          }),
                        ],
                        1
                      ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { key: _vm.refreshTab, staticClass: "d-flex" },
                [
                  _vm.isEditable
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "5" } },
                        [
                          _c("label", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t("common.security.cert_not_present")
                                ) +
                                "\n        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("b-table", {
                            attrs: {
                              "thead-class": "d-none",
                              items: _vm.listCertificateOutGroup,
                              fields: _vm.fields,
                              hover: "",
                              "select-mode": "multi",
                              selectable:
                                _vm.listCertificateOutGroup.length > 0,
                              "empty-text": "Pas de résultat",
                            },
                            on: { "row-selected": _vm.onRowSelectedOutGroup },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "cell(name)",
                                  fn: function (data) {
                                    return [
                                      _c("span", [_vm._v(_vm._s(data.value))]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3123800674
                            ),
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isEditable
                    ? _c(
                        "b-col",
                        {
                          staticClass: "align-self-top mt-4 pt-1",
                          attrs: { cols: "1" },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "back-button",
                              on: {
                                click: function ($event) {
                                  return _vm.putCertificateRight()
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-solid fa-chevron-right",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "back-button mt-3",
                              on: {
                                click: function ($event) {
                                  return _vm.putCertificateLeft()
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-solid fa-chevron-left",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "back-button mt-3",
                              on: {
                                click: function ($event) {
                                  return _vm.putAllCertificate(true)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-solid fa-angles-right",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "back-button mt-3",
                              on: {
                                click: function ($event) {
                                  return _vm.putAllCertificate(false)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-solid fa-angles-left",
                              }),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "form-group align-items-start",
                      attrs: { sm: "5" },
                    },
                    [
                      _c("label", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("common.security.cert_present")) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("b-table", {
                        attrs: {
                          "thead-class": "d-none",
                          items: _vm.listCertificateInGroup,
                          fields: _vm.fields,
                          hover: "",
                          "select-mode": "multi",
                          selectable: _vm.listCertificateInGroup.length > 0,
                          "empty-text": "Pas de résultat",
                        },
                        on: { "row-selected": _vm.onRowSelectedInGroup },
                        scopedSlots: _vm._u([
                          {
                            key: "cell(name)",
                            fn: function (data) {
                              return [_c("span", [_vm._v(_vm._s(data.value))])]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "justify-content-end no-gutter" },
                [
                  _vm.isEditable && _vm.formType !== "add"
                    ? _c(
                        "b-button",
                        {
                          staticClass: "mx-3",
                          attrs: { variant: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.switchMode("view")
                            },
                          },
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.$t("common.cncl")))])]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isEditable && _vm.formType !== "add"
                    ? _c(
                        "b-button",
                        {
                          staticClass: "mx-3",
                          attrs: { variant: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.switchMode("edit")
                            },
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("administration.edit"))),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isEditable && _vm.formType !== "add"
                    ? _c(
                        "b-button",
                        {
                          staticClass: "mx-3",
                          attrs: { variant: "primary" },
                          on: { click: _vm.deleteCA },
                        },
                        [
                          _c("i", { staticClass: "fa-light fa-trash" }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$t("rights.delete")))]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isEditable && _vm.formType !== "add"
                    ? _c(
                        "b-button",
                        {
                          staticClass: "mx-3",
                          attrs: { variant: "primary" },
                          on: { click: _vm.editCA },
                        },
                        [
                          _c("i", { staticClass: "fa-light fa-save" }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mode === "add"
                    ? _c(
                        "b-button",
                        {
                          staticClass: "mx-3",
                          attrs: { variant: "primary" },
                          on: { click: _vm.createCA },
                        },
                        [
                          _c("i", { staticClass: "fa-light fa-save" }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }